import styles from "./schedule-form.module.scss";
import { openPopupWidget } from "react-calendly";

export default function ScheduleForm({url}) {
  const onClick = () => openPopupWidget({ url });
  return (
    <div className={styles.schedule}>
      <p>Schedule some time to talk through the details</p>
      <div>
        <button className={styles.submit} onClick={onClick}>Schedule now</button>
      </div>
    </div>
  );
}
